<template>
  <div>
    <v-card class="mb-4 scrollable-card" :style="cardStyle">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="card-title">{{ props.title }}</span>
        <div class="breadcrumbs-container" :class="{ 'ms-auto': !!exportFilename }" ref="breadcrumbsContainer">
          <v-breadcrumbs 
            :items="breadcrumbs" 
            divider=">" 
            @click="handleBreadcrumbClick"
            class="text-subtitle-2 pa-0 breadcrumbs-wrapper"
            density="compact"
          ></v-breadcrumbs>
        </div>
        <v-btn
          v-if="exportFilename"
          class="rdrive-chart-export ms-1 flex-shrink-0"
          icon="mdi-download"
          variant="text"
          size="small"
          density="comfortable"
          :disabled="totalItems === 0"
          @click="downloadPng"
        />
      </v-card-title>
      <v-card-text>
        <v-chart class="chart" ref="chartRef" :style="{ height: chartHeight + 'px' }" :option="chartOption" :update-options="{ notMerge: true }" @click="handleChartClick" />
        
        <!-- Pagination controls - only shown when needed -->
        <div v-if="totalPages > 1" class="pagination-controls mt-2">
          <div class="d-flex align-center justify-space-between">
            <div class="text-body-2">
              {{ t('showing') }} {{ startItem }}-{{ endItem }} {{ t('of') }} {{ totalItems }} {{ t('items') }}
            </div>
            <div>
              <v-btn 
                size="small" 
                icon="mdi-chevron-left" 
                :disabled="currentPage === 1" 
                @click="changePage(currentPage - 1)"
                density="comfortable"
              ></v-btn>
              
              <span class="mx-2">{{ currentPage }} / {{ totalPages }}</span>
              
              <v-btn 
                size="small" 
                icon="mdi-chevron-right" 
                :disabled="currentPage === totalPages" 
                @click="changePage(currentPage + 1)"
                density="comfortable"
              ></v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
